import { useTranslation } from 'react-i18next';

import { ButtonLink } from '~/components';

import { fieldActionStyle } from '../organisationStep.css';

export const SwitchNumberType = ({
  i18nKey,
  onSwitch,
}: {
  i18nKey: 'clients:create.company.hasVatNumberLink' | 'clients:create.company.noVatNumberLink';
  onSwitch: () => void;
}) => {
  const { t } = useTranslation(['clients']);

  return (
    <div className={fieldActionStyle}>
      <ButtonLink onClick={onSwitch}>{t(i18nKey)}</ButtonLink>
    </div>
  );
};
